import { type FC } from 'react';

import { Typography } from '@vakantiesnl/components/src/atoms/Typography';

import { useBreakpoints } from '../../../utils/useBreakpoints';

type Props = {
	title: string;
	className?: string;
};

export const StepTitle: FC<Props> = ({ title, className }) => {
	const { isDesktop } = useBreakpoints();

	return (
		<Typography className={className} variant={isDesktop ? 'headingLg' : 'headingMd'} as={'h3'}>
			{title}
		</Typography>
	);
};
